import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useIsSeller } from "@/hooks/useIsSeller";
import { useSellerOtpStatus } from "@/hooks/useSellerOtpStatus";

const SellerProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const { isSeller, loading: sellerLoading } = useIsSeller();
  const { canAccessSellerArea, loading: otpLoading } = useSellerOtpStatus();
  const location = useLocation();

  // Show loading state while checking authentication, seller status, and OTP
  if (authLoading || sellerLoading || (isSeller && otpLoading)) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center text-muted-foreground">
        Loading...
      </div>
    );
  }

  // Not logged in - redirect to auth
  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  }

  // Not a seller - redirect to account
  if (!isSeller) {
    return <Navigate to="/account" replace />;
  }

  // Seller but needs 2FA (first time, or device not trusted / expired)
  if (!canAccessSellerArea) {
    return <Navigate to="/seller-2fa-setup" replace />;
  }

  // All checks passed - render the protected content
  return children;
};

export default SellerProtectedRoute;
